// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__FVSnM","logo":"Footer_logo__fIb+V"};